import PropTypes from 'prop-types';

export default function Spinner({size = 24, className = ''}) {
    return (
        <div className={`spinner${className ? ` ${className}` : ''}`} role="status" aria-label="Loading">
            <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2.5" opacity="0.2" />
                <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
            </svg>
        </div>
    );
}

Spinner.propTypes = {
    size: PropTypes.number,
    className: PropTypes.string,
};
